<!-- 发布结果 -->
<template>
	<div class="wrap">

		<div class="header">
			<img src="../assets/return.png" class="return-img">
			<p class="header-title">发布需求</p>
		</div>

		<img src="../assets/success-icon.png" class="icon">

		<span class="font-1">发布成功</span>

		<span class="font-2">需求正在审核中，感谢您对行业做出的贡献</span>

		<span class="font-3">打开系统通知开关，及时获悉稿件状态 <button type="button" class="btn">去设置</button> </span>

		<button type="button" class="btn-2"   @click="$router.push('/demand')">我的发布</button>

	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {

			};
		},
		mounted() {},
		methods: {

		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		min-height: 100vh;
		background-color: #F4F4F4;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 44px 15px 15px;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #F4F4F4;
		z-index: 999;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.icon {
		width: 48px;
		margin: 40px 0 15px;
	}

	.font-1 {
		color: #2A63F3;
		font-size: 18px;
		font-weight: 500;
		margin-bottom: 45px;
	}

	.font-2 {
		color: #222222;
		font-size: 14px;
		margin-bottom: 7px;
	}

	.font-3 {
		color: #999999;
		font-size: 14px;
	}

	.btn {
		color: #2A63F3;
		font-size: 14px;
		margin-left: 3px;
	}

	.btn-2 {
		color: #FFFFFF;
		font-size: 18px;
		font-weight: 500;
		background-color: #2A63F3;
		border-radius: 100px;
		width: 135px;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 77px;
	}
</style>
